import { useClient } from '@composables/use-clients';
import {
  GetRequestArgsType,
} from '@api/v1/types';
import { useTenantStore } from '@stores/tenant-store';
import { urls } from '@api/urls';
import { withTryCatch } from '@api/v1/error-handlers';

export type GetReviewSkillMetricsArgsType = GetRequestArgsType & {
  reviewCode: string;
  reviewSkillId: number;
};

export const apiFetchReviewSkillMetrics = async ({
  domain = useTenantStore().domain,
  reviewCode,
  reviewSkillId,
  errorConfig = {},
  callbacks = {},
}: GetReviewSkillMetricsArgsType) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.get({
      url: urls.v1.reviewSkillMetrics({ domain, reviewCode, reviewSkillId }),
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};
